export default "__VITE_ASSET__BC$7Bt8Y__"